import { render, staticRenderFns } from "./add-vip.vue?vue&type=template&id=99a42524&scoped=true&"
import script from "./add-vip.vue?vue&type=script&lang=js&"
export * from "./add-vip.vue?vue&type=script&lang=js&"
import style0 from "./add-vip.vue?vue&type=style&index=0&id=99a42524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a42524",
  null
  
)

export default component.exports